<template>
  <div
    class="table-saved-filters f-column"
    style="min-height: 0"
  >
    <div class="f-align-center w-100 no-scroll-track">
      <div class="text-normal my-auto f-center weight_600 text-nowrap">
        {{ $t('data_table.saved_ranges.title') }}
      </div>

      <GwFilter
        class="ml-2"
        :asRow="true"
        :hasSaveBtn="false"
        :hasClearBtn="false"
        filterUrlPrefix="ffsr"
        filterConfigKey="savedRanges"
      />
    </div>

    <TableBody
      ref="tablebody"
      class="gw_table_small gw_table_simple mt-2"
      :items="tcrud_items"
      :loading="tcrud_loading"
      :error="tcrud_error"
      :isInfinite="true"
      size="small"
      keyField="id"
      style="--clr-back-body: var(--clr-black-0-3)"
    >
      <template #no_data>
        <div
          class="gw_box flex-1 f-center"
          style="--clr-box-back: var(--clr-black-0-3)"
        >
          <IconAndText
            v-if="filter.active"
            class="my-auto"
            icon="mdi-filter"
            :title="$t('data_table.saved_ranges.no_items')"
            :subtitle="$t('data_table.saved_ranges.no_data')"
          />
          <IconAndText
            v-else
            class="my-auto"
            icon="mdi-table"
            :title="$t('data_table.saved_ranges.no_items')"
            :subtitle="$t('data_table.saved_ranges.no_items_sub')"
          />
        </div>
      </template>
      <template #default="{ item, index }">
        <SavedRangesTableV1Row
          :thead="thead"
          :item="item"
          tagType="saved_ranges"
          :allTags="allTags"
          :mobile="mobile"
          :index="index"
          :isSelected="!!tcrud_selectedItems[index]"
          :draggedItems="tcrud_draggedItems"
          :dragDisabled="tbl_sortConf.sortKey !== 'ordering_position'"
          @apply:item="applyItem(item)"
          @open:detail="openSaveRangeDialog(item)"
          @click:tag_item="tag => tcrud_handleTagClick({ item, tag })"
          @drag:start="e => tcrud_handleDragstart({ e, item })"
          @delete:item="tcrud_deleteItem(item)"
        >
        </SavedRangesTableV1Row>
      </template>
    </TableBody>

    <DragDropHandler
      ref="dragdrophandler"
      :getIndicatorStyle="tcrud_getDragIndicatorStyle"
      :proccessEvent="tcrud_scrollTable"
      dropTargetIdPart="saved-ranges_table_row"
      @drag:drop="tcrud_handleDragdrop"
    >
      <template #shallowitem>
        <div
          class="gw_box"
          style="--clr-box-back: var(--clr-primary)"
        >
          <div
            v-if="tcrud_draggedItems.length > 1"
            class="truncate"
          >
            {{
              $t('common.xxx_selected_items', {
                num: tcrud_draggedItems.length,
              })
            }}
          </div>
          <div v-else-if="tcrud_draggedItem">
            {{ tcrud_draggedItem.name }}
          </div>
        </div>
      </template>
    </DragDropHandler>
  </div>
</template>

<script>
import IconAndText from '@/components/Poker/Overlays/IconAndText'
import GwFilter from '@/components/DataTables/Filters/new/GwFilter'
import { getTagFilteredTableData } from '@/store/tableFilters/tableFilters'

import TableBody from '@/components/DataTables/v2/TableBody'
import DragDropHandler from '@/components/lib/DragDropHandler'

import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'
import tcrud_mix from '@/components/DataTables/tcrud_mix'
import SavedRangesTableV1Row from '@/components/DataTables/v2/tables/SavedRangesTableV1/SavedRangesTableV1Row'

export default {
  name: 'SavedRangesTableV1',
  components: {
    TableBody,
    SavedRangesTableV1Row,
    DragDropHandler,
    IconAndText,
    GwFilter,
  },
  mixins: [tcrud_mix, table_mix, float_mix],
  props: {
    namespace: { String, required: true },
    // tableFilterId: { String, required: true },
  },
  emits: ['apply:item', 'loaded'],
  data() {
    this.tcrud_conf = {
      getEndpoint: item => `poker/custom-solutions/custom-trees/saved-ranges/${item.id}/`,
      getDeleteEndpoint: item => `poker/custom-solutions/custom-trees/saved-ranges/${item.id}/`,
      deleteSuccessMessage: 'messages.success_range_delete',
      deleteErrorMessage: 'messages.error_range_delete',
      idKey: 'id',
    }

    // this.tbl_persistSortKey = 'savedsolutions_sort'
    this.tcrud_endpoint = 'poker/custom-solutions/custom-trees/saved-ranges/'
    this.tcrud_mutation = 'api_poker_saved_ranges_table'
    this.tcrud_apiVersion = 'v1'
    return {
      tbl_sortConf: {
        sortKey: 'ordering_position',
        sortOrder: 'asc',
      },
      selectedRows: [],
      lastTouchedIdx: -1,
      detailItem: null,

      tcrud_limit: 9999,
      tcrud_offset: 0,
    }
  },
  created() {
    this.tbl_setSortConf()
    this.tcrud_getDataCheck()
  },
  methods: {
    applyItem(item) {
      this.$emit('apply:item', item)
    },
    openSaveRangeDialog(item) {
      const newRange = {
        id: item.id,
        name: item.name,
      }
      this.$store.commit(`${this.namespace}/slfrm_set`, {
        key: 'slfrm_selectedRange',
        value: newRange,
      })
      this.$store.dispatch(
        'router_set_dialogs',
        `solfigr-save-range-dialog_namespace-${this.namespace}`,
      )
    },
  },
  computed: {
    allTags() {
      return this.$store.getters.tags_get_all_tags('saved_ranges')
    },
    thead() {
      const cols = {
        name_description: {
          name: this.$t('table_head.name'),
          sortKey: 'name',
          width: 16,
        },
        tags: {
          name: this.$t('table_head.tags'),
          // minWidth: ,
          width: 11,
        },
        actions: {
          name: '',
          width: 1.75,
        },
      }
      const res = {}
      Object.keys(cols).forEach(key => {
        const col = cols[key]
        const width = col.width || col.minWidth
        res[key] = {
          ...col,
          cssStyle: !width
            ? ''
            : `
            --min-width-th: ${width}rem;
            ${col.minWidth ? '' : `--max-width-th: ${width}rem`};
            `,
          tdStyle: !width
            ? ''
            : `
            --min-width-td: ${width}rem;
            ${col.minWidth ? '' : `--max-width-td: ${width}rem`};
            `,
        }
      })
      // console.log(res)
      return res
    },
    tcrud_apiData() {
      return this.$store.getters.api_get_data(this.tcrud_mutation)
    },
    tcrud_itemsDrag() {
      const res = this.tcrud_apiData?.results || []
      const { sortKey, sortOrder } = this.tbl_sortConf
      if (sortOrder === 'desc') {
        res.sort((a, b) => (a[sortKey] > b[sortKey] ? -1 : 1))
      } else {
        res.sort((a, b) => (a[sortKey] < b[sortKey] ? -1 : 1))
      }
      return res
    },
    tcrud_items() {
      let res = this.tcrud_apiData?.results || []
      res = getTagFilteredTableData({
        items: res,
        allTags: this.allTags,
        tagIds: this.filter.filter?.tags || [],
        anyall: this.filter.filter?.tags_anyall,
      })
      const { sortKey, sortOrder } = this.tbl_sortConf
      if (sortOrder === 'desc') {
        res.sort((a, b) => (a[sortKey] > b[sortKey] ? -1 : 1))
      } else {
        res.sort((a, b) => (a[sortKey] < b[sortKey] ? -1 : 1))
      }
      // debugger
      // res = [...res, ...res, ...res]
      // res = [...res, ...res, ...res]
      // res = [...res, ...res, ...res]
      // res = res.map((i, idx) => ({ ...i, id: idx }))
      return res
    },
    // tcrud_hasNext() { return !!this.tcrud_apiData?.links?.next },
    tcrud_apiCall() {
      return this.$store.getters.api_get(this.tcrud_mutation)
    },
    tcrud_loading() {
      return this.tcrud_apiCall?.loading
    },
    tcrud_error() {
      return this.tcrud_apiCall?.error
    },
    tcrud_loaded() {
      return this.tcrud_apiCall?.loaded
    },
    filter() {
      return this.$store.getters.ffsr
    },
    tcrud_params() {
      // let res = !this.filter.loaded
      //   ? {}
      //   : {
      //       limit: this.tcrud_limit,
      //       offset: this.tcrud_offset,
      //     }
      // return res
      return {
        limit: this.tcrud_limit,
        offset: this.tcrud_offset,
      }
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
    globals_action() {
      return this.$store.getters.globals_action
    },
  },
  watch: {
    globals_action(a) {
      if (a === 'SavedRangesTableV1') {
        this.tcrud_getData()
        this.$store.dispatch('globals_action', '')
      }
    },
    tcrud_loaded() {
      this.$emit('loaded')
    },
  },
}
</script>
